import { ComponentType, PropsWithChildren } from 'react';
import { MetaTagConfig } from './metaTagConfig';

export enum MetaFollowVariant {
  NoFollow = 'nofollow',
  Follow = 'follow',
  Empty = 'empty',
}

const renderMetaRobots = (noindex?: boolean, nofollow?: MetaFollowVariant) => {
  let content: string[] = [];

  if (nofollow === MetaFollowVariant.NoFollow) {
    content.push('nofollow');
  }
  if (nofollow === MetaFollowVariant.Follow) {
    content.push('follow');
  }

  if (noindex) {
    content.push('noindex');
  }

  if (content.length === 0) {
    return null;
  }

  return <meta content={content.join(', ')} name="robots" />;
};

export interface PageMetaTagsProps {
  tagsConfig?: MetaTagConfig[];
  /** @deprecated */
  isClosedForRobots?: boolean;
  noindex?: boolean;
  nofollow?: MetaFollowVariant;
  /** Component to render Head like react-helmet */
  HeadComponent: ComponentType<PropsWithChildren>;
}
export const PageMetaTags = ({
  HeadComponent,
  tagsConfig,
  noindex,
  nofollow = MetaFollowVariant.Empty,
  isClosedForRobots,
}: PageMetaTagsProps) => (
  <HeadComponent>
    {tagsConfig?.map(({ tagName, tagContent }) => {
      if (tagName === 'title') {
        return <title key={tagName}>{tagContent}</title>;
      }

      return <meta content={tagContent} key={tagName} name={tagName} />;
    })}
    {isClosedForRobots ? renderMetaRobots(true, MetaFollowVariant.Follow) : renderMetaRobots(noindex, nofollow)};
  </HeadComponent>
);
